export default "__VITE_ASSET__BtrfTE6T__"